import { SUPER_ADMIN } from "@/components/data/constants";
import { useActiveSession } from "@/hooks/useActiveSession";
import { ActionIcon } from "@mantine/core";
import { IconMessage2 } from "@tabler/icons-react";
import { useNavigate } from "@tanstack/react-router";

export function HeaderChatButton() {
  const navigate = useNavigate();
  const { userType, modules } = useActiveSession();
  const hasChatAccess = userType === SUPER_ADMIN || (modules ?? []).includes("chat");

  if (!hasChatAccess) {
    return null;
  }

  return (
    <ActionIcon
      variant="subtle"
      c="var(--icon-default)"
      aria-label="Chat"
      onClick={() => navigate({ to: "/chat" })}
    >
      <IconMessage2 size={16} />
    </ActionIcon>
  );
}
